<template>
  <section>
      <section v-if="selectedFlight && flightModel && flightDetails && flightPrice">
          <section v-show="step == 1">
            <div class="view__header">
                <div class="container text-center mx-auto">
                    <h4 class="view__header--text">Trip Summary</h4>
                    <div class="notification-header mt-4 d-flex justify-content-center">
                        <img src="@/assets/TAJimages/flight/check-icon.svg" alt="check">
                        <p class=" ml-2 notification-text">Nice job! You picked one of our best value flights. <span class="font-weight-bold">Book now so you don’t miss out on this price.</span></p>
                    </div>
                </div>
            </div>
            <div class="tab-section">
                <div class="tab-items d-flex">
                    <div class="pb-1" :class="tabItems === 'itinerary'? 'active-border': ''">
                        <h5 @click="switchTab('itinerary')">Itinerary</h5>
                    </div>
                    <div class="pb-1" :class="tabItems === 'fareRules'? 'active-border': ''">
                        <h5 @click="switchTab('fareRules')">Fare rules</h5>
                    </div>
                    <div class="pb-1" :class="tabItems === 'customMessages'? 'active-border': ''">
                        <h5 @click="switchTab('customMessages')">Custom messages</h5>
                    </div>
                </div>
            </div>
            <section class="tab__section my-5">
                <!-- {{flightDetails.flightModels}} -->
                <div class="row">
                    <div class="col-lg-7 right-side animated fadeIn" v-if="tabItems === 'itinerary'">
                        <section v-for="(item, l) in flightDetails.flightModels" :key="l">
                            <div class="departure--section mb-5">
                                <h5 class="departure-header">Departure flight : {{item.departureName}} - {{item.arrivalName}}</h5>
                                <div class="line"></div>
                                <div class="flight-about">
                                    <p class="flight-about-date">{{item.departureTime | momentDate}}</p>
                                    <div class="flight-about-items d-flex">
                                        <img :src="item.airlineLogoUrl" height="40" class="mr-3" alt="">
                                        <div>
                                            <div v-for="(name, m) in item.flightLegs" :key="m">
                                                <h6 class="departure-header">{{name.startTime | dayjs}} - {{name.endTime | dayjs}}</h6>
                                                <p class="airport-name">{{name.departureName}} ({{name.departureCode}}) - {{name.destinationName}} ({{name.destinationCode}})</p>
                                                <p class="flight-type mb-2 resize-w">Trip Duration: <span class="span-text">{{name.duration}}</span></p> 
                                                <p class="flight-type">{{name.operatingCarrierName}} . {{name.flightNumber}}. Cabin Class {{name.cabinClass}}. <br> Booking Class {{name.bookingClass}}</p>
                                                <p class="flight-type mb-1 resize-w">Layover: <span class="span-text">{{name.layover ? name.layover : 'N/A'}}</span></p>
                                                <p class="flight-type mb-1 resize-w">Layover Duration: <span class="text-success span-text">{{name.layoverDuration ? name.layoverDuration : 'N/A'}}</span></p>
                                                <p class="airport-name mb-1 mt-3">Technical Stops:</p>
                                                <p class="flight-type" v-if="name.technicalStops.length < 1"><span class="text-danger">*No Technical Stops</span></p>
                                                <div v-for="(stop, z) in name.technicalStops" :key="z">
                                                    <p class="flight-type resize-w">Airport Name: <span class="span-text">{{ stop.airportName}} ({{ stop.airportCode}})</span></p>
                                                    <p class="flight-type resize-w">Departure Date: <span class="span-text">{{ stop.departureDate | momentDate}}</span></p>
                                                    <p class="flight-type resize-w">Arrival Date: <span class="span-text">{{ stop.arrivalDate | momentDate}}</span></p>
                                                    <p class="flight-type resize-w">Duration: <span class="text-success span-text">{{ stop.duration }}</span></p>
                                                </div>
                                                <p class="flight-type mb-5 mt-1">{{name.cabinClassName}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    <h5 class="flight-time my-3">Total Duration: {{item.tripDuration}}</h5>
                                <div class="flight-luggage d-flex align-items-center">
                                    <img src="@/assets/TAJimages/flight/briefcase-icon.svg" class="mr-3" alt="">
                                    <p class="mb-0">{{item.freeBaggage.bagCount}}PCS x {{item.freeBaggage.weight === 0 || item.freeBaggage.weight === null || item.freeBaggage.weight === '' ? '23' : item.freeBaggage.weight}}Kg</p>
                                </div>
                            </div>
                        </section>
                        
                    </div>
                    <div class="col-lg-7 right-side animated fadeIn" v-if="tabItems === 'fareRules'">
                        <h6>Penalty Applies</h6>
                        <div class="line"></div>
                        <div class="rules" v-for="(rules, q) in flightDetails.fareRules" :key="q + 2">
                            <p v-html="rules"></p>
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-lg-7 right-side animated fadeIn" v-if="tabItems === 'customMessages'">
                      <div v-if="selectedFlight.customMessages.length > 0">
                        <div class="rules" v-for="(name, q) in selectedFlight.customMessages" :key="q + 5">
                            <h6>{{ name.title }}</h6>
                            <p v-html="name.message"></p>
                            <div class="line"></div>
                        </div>
                      </div>
                      <h6 v-else>No Custom Messages</h6>
                    </div>
                    <div class="col-lg-5 animated fadeIn">
                        <div class="fare-summary text-white p-4">
                            <h5>Fare Summary</h5>
                            <div class="line-1"></div>
                            <div class="d-flex justify-content-between">
                                <div class="traveler-text">
                                    <h5>Traveler(s)</h5>
                                    <h6 v-if="flightDetails.adults > 0">Adults (x{{flightDetails.adults}})</h6>
                                    <h6 v-if="flightDetails.children > 0">Children (x{{flightDetails.children}})</h6>
                                    <h6 v-if="flightDetails.infants > 0">Infants (x{{flightDetails.infants}})</h6>
                                </div>
                                <h5 class="trav-amount">N{{new Intl.NumberFormat('en-NG', {}).format(flightPrice.amount)}}</h5>
                            </div>
                            <div class="line-2"></div>
                            <div class="d-flex justify-content-between">
                                <h6 class="trav-amount">Total</h6>
                                <h6 class="trav-amount">N{{new Intl.NumberFormat('en-NG', {}).format(flightPrice.amount)}}</h6>
                            </div>
                            <div class="line-2"></div>
                            <p class="sub-text">*{{ flightDetails.isRefundable ? 'Refundable' : 'Non Refundable'}} <span v-if="flightDetails.nonRefundableFreeText">({{ flightDetails.nonRefundableFreeText}})</span>.</p>
                            <div v-if="flightDetails.penaltyRules.length > 0">
                              <p class="sub-text" v-for="(penalty, index) in flightDetails.penaltyRules" :key="index" style="width:300px">*{{penalty}}</p>
                            </div>
                            <div class="text-center mt-5">
                                <button class="btn btn-primary py-2" @click="step++">Continue Booking</button>
                            </div>
                            <div class="text-center mt-2">
                                <router-link to="/lifestyle/flight/search">
                                    <button type="button" class="btn btn-outline-none text-white">Go Back</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <!-- continue booking -->
        <passengerDetails v-show="step == 2" @goBack="step--" @nextStep="step++"/>
        <!-- input details section -->
        <section v-show="step == 3" class="px-4 details-section animated fadeIn">
            <div class="row">
                <div class="col-lg-7 offset-lg-2">
                    <div class="continue-booking border-sm">
                        <div v-show="isOtpPage == 1">
                            <h5 class="py-3 text-center payment-header">Payment</h5>
                            <hr class="my-0">
                            <div class="form-group p-5">
                                <label for="surname" class="form-label">Select From Account <span class="text-danger">*</span></label>
                                <select @change="fetchFlightFee" v-model="submitForm.accountNumber" placeholder="Select From Account *" class="form-control" required="required">
                                    <option value="">Select From Account *</option>
                                    <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                </select>
                                <div class="form-group mt-4">
                                    <label for="pin" class="form-label">Transaction Pin <span class="text-danger">*</span></label>
                                    <input @keypress="isNumber" @click="removeReadonly2" id="no-paste-2" v-model="submitForm.transactionPin" class="form-control" placeholder="Enter Transaction Pin *" maxlength="4" :type="type"/>
                                      <span @click="showPin" class="pull-right show-pin">{{type === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                                <div class="mb-3 row" v-if="isVatFee">
                                    <div class="col-lg-12">
                                        <p>Note that a transaction fee of <span style="color:#E41613;">N{{vatFee}}</span> would apply.</p>
                                    </div>
                                </div>
                                <div class="mt-5 d-flex justify-content-center align-items-center text-center">
                                    <p @click="step--" class="text-danger mr-5 mb-0 font-weight-bold" style="cursor:pointer">Back</p>
                                    <button type="button" :disabled="loading" @click="submitFlightForm" class="btn btn-danger">
                                        <div v-if="loading">Please wait...</div> 
                                        <div v-else>Pay for Flight</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-show="isOtpPage == 2" class="animated fadeIn px-5 py-5 text-center succes-page">
                            <img src="@/assets/TAJimages/flight/flying-world.svg" alt="">
                            <h6>Flight booked successfully!</h6>
                            <p>Thanks for banking with us.</p>
                            <button type="button" @click="exitPage" class="btn btn-danger">Exit</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </section>
      <div v-if="isLoading" class="loader-12"></div>
  </section>
</template>

<script>
  import { decrypt } from '@/_services/encryption';
  import { mapActions, mapState } from 'vuex';
  import moment from 'moment';
  import dayjs from 'dayjs';
  import passengerDetails from '@/components/passengerDetails.vue';
  export default {
    components: {
      passengerDetails
    },
    filters: {
      dayjs: function (date) {
        return dayjs(date).format('hh:mma');
      },
      momentDate: function (date) {
        return moment(date).format('DD MMM, YYYY');
      }
    },
    data:() => ({
      tabItems: 'itinerary',
      step: 1,
      isOtpPage: 1,
      showMemberPromo: false,
      showCorporatePromo: false,
      isLoading: false,
      passengerDetails: [],
      bookingItemModels: [],
      form: {
        title: '',
        passengerType: '',
        firstName: '',
        lastName: '',
        middleName: '',
        dateOfBirth: '',
        age: '',
        phoneNumber: '',
        address: '',
        passportNumber: '',
        expiryDate: '',
        email: '',
        gender: '',
        city: '',
        country: '',
        postalCode: '',
      },
      bookingDetails: {
        bookingId: '',
        targetCurrency: 'NGN',
        bookingData: '',
        productType: 'Flight',
      },
      checked: false,
      loading: false,
      submitForm: {
        accountNumber: '',
        pnrNumber: '',
        bookingId: '',
        appPlatform: 1,
        transactionReference: '',
        transactionPin: '',
      },
      type: 'password',
      vatFee: '',
      isVatFee: false
    }),
    computed: {
      ...mapState('flight', ['selectedFlight', 'bookingData']),
      ...mapState({
        account: state => state.dashboard.dashboardData,
      }),
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      routeId() {
        return this.$route.params.id;
      },
      flightModel() {
        return this.selectedFlight ? this.selectedFlight.flightSummaryModel : {};
      },
      flightDetails() {
        return this.flightModel ? this.flightModel.flightCombination : {};
      },
      flightPrice() {
        return this.flightDetails ? this.flightDetails.price : {};
      },
      flightMainInfo() {
        return this.flightDetails ? this.flightDetails.flightModels : [];
      },
      getFlightPriceDetails() {
        return this.flightDetails ? this.flightDetails.priceDetails : {};
      }
    },
    async mounted() {
      this.getAllCountries()
      const data = {
        selectData: this.routeId,
        targetCurrency: 'NGN',
        appPlatform: 1,
      };
      this.isLoading = true;
      try {
        await this.getSelectedFlight(data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        const decryptedError = decrypt(error.response.data);
        const objError = JSON.parse(decryptedError);
        this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          }).then(() => {
          this.$router.push('/lifestyle/flight/search')
        })
      }
    },
    methods: {
      ...mapActions('flight', ['getSelectedFlight', 'bookFlight', 'payForFlight', 'getAllCountries']),
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      switchTab(tab) {
        this.tabItems = tab;
      },
      removeReadonly2() {
        document.getElementById('no-paste-2').removeAttribute('readonly');
      },
      showDropdown(type) {
        switch (type) {
        case 'memberPromo':
          this.showMemberPromo = !this.showMemberPromo;
          break;
        case 'corporatePromo':
          this.showCorporatePromo =  !this.showCorporatePromo;
          break;
        }
      },
      fetchFlightFee () {
        const data = {
          accountNumber: this.submitForm.accountNumber,
          transactionType: 16,
          amount: this.flightPrice.amount,
          platform: 1,
        };
        this.$store.dispatch('transfers/transactionEnquiry', data).then(async (response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          this.submitForm.transactionReference = userParseData.transactionReference;
          this.vatFee = userParseData.fee.total;
          if (response.status === 200) {
            this.isVatFee = true;
          }
        }).catch((error) => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
          this.loading = false;
        });
      },
      async submitFlightForm() {
        this.submitForm.bookingId = this.bookingData.bookingId;
        this.submitForm.pnrNumber = this.bookingData.pnrNumber;
        if(this.submitForm.accountNumber === '' || this.submitForm.transactionPin === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill in all the fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else {
          this.loading = true;
          try {
            await this.payForFlight(this.submitForm);
            this.loading = false;
            this.isOtpPage++;
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          }
        }
      },
      exitPage() {
        this.$router.push({
          name: 'flight',
        });
        window.location.reload();
      },
    }
  };
</script>

<style scoped>
  .resize-w {
    font-weight: 700 !important;
    color: #1F1F1F !important;
  }
  .span-text {
    color: #818F9B;
    opacity: 1;
    font-size: 13px;
  }
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.view__header {
    background: #EAF0F3;
    height: 100%;
    padding-top: 40px;
    padding-bottom: 10px;
}
.view__header--text {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-weight: bold;
    font-size: 15px;
}
.notification-header {
    padding: 10px;
    background: #D4EDDA 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 789px;
}
.notification-text {
    letter-spacing: 0.3px;
    color: #155724;
    opacity: 1;
    margin-bottom: 0;
}
.tab-section {
    height: 42px;
    background: #E1ECF3 0% 0% no-repeat padding-box;
    opacity: 1;
}
.tab-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    width: 500px;
    margin: 0 auto;
    cursor: pointer;
}
.tab-items h5 {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 16px;
    font-weight: 500;
}
.tab-items h5:last-child {
    color: #818F9B;
}
.tab__section {
    padding: 10px 50px;
}
.right-side {
    height: 500px;
    overflow: scroll;
}
.right-side-form {
    height: 700px;
    overflow: scroll;
}
.line {
    height: 1px;
    background: #E1ECF3;
    border: 1px dotted #E1ECF3;
    width: 90%;
    margin: 10px 0px;
}
.line-1 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #6D757D;
    margin: 20px 0px;
}
.line-2 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #E1ECF3;
    margin: 20px 0px;
}
.departure-header {
    letter-spacing: 0.4px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.fare-summary {
    width: 375px;
    height: 100%;
    background: #223344 0% 0% no-repeat padding-box;
    opacity: 1;
    /* position: fixed; */
}
.flight-luggage {
    background: #FDF9EC 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 20px;
    width: 90%;
}
.flight-luggage p {
    letter-spacing: 0.34px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
}
.flight-about-date {
    letter-spacing: 0.34px;
    color: #818F9B;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.airport-name {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
    font-weight: normal;
    width: 387px;
}
.flight-type {
    letter-spacing: 0.3px;
    color: #818F9B;
    opacity: 1;
    font-size: 15px;
}
.flight-time {
    letter-spacing: 0.34px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.traveler-text h5,
.trav-amount {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.traveler-text h6 {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.rules h6 {
    letter-spacing: 0.36px;
    color: #3A4248;
    opacity: 1;
    font-size: 18px;
}
.rules p {
    letter-spacing: 0.24px;
    color: #3A4248;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.sub-text {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
}
.continue-booking {
    background: #FFFFFF;
    opacity: 1;
}
.booking-header h5 {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 17px;
    font-weight: bold;
}
.booking-notification-header {
    background: #F2F2FF 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 10px 15px;
}
.booking-notification-text {
    letter-spacing: 0.3px;
    color: #6569B5;
    opacity: 1;
    margin-bottom: 0;
    font-size: 11px;
}
.booking-pass-text {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.fa-angle-down {
    cursor: pointer;
}
input::placeholder,
textarea::placeholder,
option {
    font-size: 14px;
    color: #ACACAC;
    font-weight: 400;
}
.p-text {
    letter-spacing: 0.28px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: bold;
}
.sub-p-text {
    letter-spacing: 0.28px;
    color: #6D8494;
    opacity: 1;
    font-weight: normal;
    font-size: 13px;
    margin-bottom: 4px;
}
.arrives-text {
    letter-spacing: 0.28px;
    font-size: 13px;
    margin-bottom: 0;
    color: #E41613;
}
.total-sec h5 {
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    font-size: 18px;
}
.total-sec h6 {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 18px;
}
.footer-sec {
    background: #FFF0E4;
    padding: 15px 20px;
    text-align: center;
    color: #223344;
    opacity: 1;
}
.footer-sec p {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
}
.details-section {
    /* padding: 40rem 0; */
    padding-top: 5rem;
}
.payment-header {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    margin-bottom: 0;
    font-size: 18px;
}
.border-sm {
    border-radius: 7px;
}
.otpPage p {
    letter-spacing: -0.18px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
}
.otpPage h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
}
.succes-page h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
    margin-top: 50px;
}
.succes-page p {
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 60px;
}
.active-border {
    border-bottom: 2px solid #F58220;
}
.show-pin {
  font-size: 12px;
  color: #E41613;
  cursor: pointer;
}
</style>